import Axios from 'axios'
import {pageTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_page_types (context) {
    Axios.get(pageTypeUrls.getAllPageTypes).then(function (response) {
      context.commit('GET_ALL_PAGE_TYPES', response.data)
    })
  },
  get_page_types (context, publicId) {
    Axios.get(pageTypeUrls.getPageTypes + publicId).then(function (response) {
      context.commit('GET_PAGE_TYPES', response.data)
    })
  },
  get_deleted_page_types (context) {
    Axios.get(pageTypeUrls.getDeletedPageType).then(function (response) {
      context.commit('GET_DELETED_PAGE_TYPES', response.data)
    })
  },
  get_page_type (context, publicId) {
    Axios.get(pageTypeUrls.getPageType + publicId).then(function (response) {
      context.commit('GET_PAGE_TYPE', response.data)
    })
  },
  post_page_type (context, data) {
    Axios.post(pageTypeUrls.postPageType, data).then(function () {
      context.dispatch('get_all_page_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_page_type (context, data) {
    Axios.post(pageTypeUrls.editPageType, data).then(function () {
      context.dispatch('get_all_page_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_page_type (context, publicId) {
    Axios.get(pageTypeUrls.deletePageType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_PAGE_TYPES', response.data)
      router.push({
        name: 'Module.DeletedPageTypes'
      })
    })
  },
  restorePageType (context, publicId) {
    Axios.get(pageTypeUrls.restorePageType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_PAGE_TYPES', response.data)
      router.push({
        name: 'Module.PageTypes'
      })
    })
  }
}
